var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPieChartIconWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 32.00 32.00",
    id: "OBJECT",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.00032,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#CCCCCC",
    strokeWidth: 0
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff; opacity: 0.5;}")), /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.49,4.51A12,12,0,1,0,13,25a1,1,0,0,0,1-1V13.41l7.49-7.49a1,1,0,0,0,.29-.7A1,1,0,0,0,21.49,4.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.49,6.51a1,1,0,0,0-1.41,0l-7.79,7.78a1,1,0,0,0-.29.79,1,1,0,0,0,.42.73l9,6.4a1,1,0,0,0,.58.19l.16,0a1,1,0,0,0,.65-.4A12,12,0,0,0,27.49,6.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.54,24.58l-9-6.39A1,1,0,0,0,16,19V30a1,1,0,0,0,1,1,12.06,12.06,0,0,0,9.77-5,1,1,0,0,0,.17-.75A1,1,0,0,0,26.54,24.58Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPieChartIconWhite);
export default __webpack_public_path__ + "static/media/pie-chart-icon-white.b89c7b879fbe09c2c21db22291f381f2.svg";
export { ForwardRef as ReactComponent };